import classNames from "classnames";
import { ContactAvatar } from "components/Atoms/Avatar";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

declare let document: any;

interface IContactBirthdayItem {
  birthday: server.dto.ContactBirthday
}

const ContactBirthdayRowCard = ({ birthday }: IContactBirthdayItem) => {
  const birthdayClick = () => {
    document.location.href = routes.contact_Detail(birthday.contactId).absolute;
  };

  const cardClasses = classNames("radius hoverable", "birthday-contact-card", {
    "aged-recently": birthday.agedRecently
  });

  return (
    <div className={cardClasses} onClick={birthdayClick}>
      {birthday.isValidated
        ? <ContactAvatar name={birthday.fullName} profileImageUrl={birthday.profileImageUrl} gender={birthday.gender} />
        : <span title={birthday.fullName}>
          <PhosphorWarning iconSize="large" />
        </span>}
      <div className="grow1">
        <div>{birthday.fullName}</div>
        <div className="aged-message text-sublabel">{birthday.agedMessage}</div>
      </div>
      <div className="birth-text s1_small">
        {birthday.birthText}
      </div>
    </div>
  );
};

export default ContactBirthdayRowCard;
